module.exports = __webpack_public_path__ + "static/media/Screenshot7.5803251f.png";